import React, { useEffect, useRef, useState } from 'react';
// import Favicon from 'react-favicon';
import { Helmet } from 'react-helmet';
import { useDispatch, useSelector } from 'react-redux';
import { useLocalStorage } from 'hooks/useLocalStorage';
import { Stock } from 'store/stock/actions';
import { Auth } from 'store/auth/actions';
import { balanceApi } from 'helpers/api/balance';
import { Rent, Reservation } from 'store/transferAct/actions';
import { userDataSelector, userOptionSelector } from 'store/auth/selectors';
import { stockListSelector, stockSelector } from 'store/stock/selectors';
import { useFirstRender } from 'hooks/useFirstRender';
import { MainHeader } from './components/MainHeader';
import { Navbar } from './components/Navbar';
import { MainPageContent } from './components/MainPageContent';
import { useQueryParam, StringParam, withDefault } from 'use-query-params';
import './style.scss';
import { useHistory } from 'react-router-dom';
import useFaviconBadgeNotify from 'favicon-badge-notify';
import faviconSvg from 'bp-favicon.svg';

const routerActionOnFirstRoute = 'POP';

const MainPage = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const userData = useSelector(userDataSelector);
  const stockList = useSelector(stockListSelector);
  const stock = useSelector(stockSelector);
  const firstRender = useFirstRender();
  const timerRef = useRef(null);
  const [stockQueryParam, setStockQueryParam] = useQueryParam('stock', withDefault(StringParam, ''));
  const userOption = useSelector(userOptionSelector);
  const [isTable, setIsTable] = useLocalStorage('isTable', false);
  const [statusQueryParam, setStatusQueryParam] = useQueryParam('status', withDefault(StringParam, ''));
  const [status, setStatus] = useState(statusQueryParam);
  const [clientType, setClientType] = useQueryParam('clientType', withDefault(StringParam, ''));
  const [string, setString] = useQueryParam('string', withDefault(StringParam, ''));
  const [itemQueryParam, setItemQueryParam] = useQueryParam('item', withDefault(StringParam, ''));
  const [item, setItem] = useState();
  const [columnSearch, setColumnSearch] = useState({ item: clientType, string });
  const [isFirstRoute, setIsFirstRoute] = useState(history.action === routerActionOnFirstRoute);

  const [count, setCount] = useState(0);
  const [favicon, setFavicon] = useState(faviconSvg);
  const { drawBadge, destroyBadge } = useFaviconBadgeNotify({
    src: faviconSvg,
    badgeValue: count,
  });

  useEffect(() => {
    drawBadge(count).then((badge) => setFavicon(badge));
    return () => destroyBadge();
  }, [count]);

  useEffect(() => {
    setIsFirstRoute(history.action === routerActionOnFirstRoute);
  }, [history]);

  useEffect(() => {
    setStatusQueryParam(status === '' ? undefined : status);
  }, [status]);

  useEffect(() => {
    const init = async () => {
      if (firstRender) {
        if (!item && itemQueryParam) {
          const { data: item } = await balanceApi.getCurrentBalance(itemQueryParam);
          setItem(item);
        }
        return;
      }
      setItemQueryParam(item?.itemID);
    };
    init();
  }, [item]);

  useEffect(() => {
    setClientType(columnSearch.item);
    setString(columnSearch.string);
  }, [columnSearch]);

  useEffect(() => {
    if (stockList === null) {
      dispatch(Stock.getStockList(stockQueryParam));
    } else if (!isFirstRoute && firstRender) {
      dispatch(Stock.pingStockList());
    }
    dispatch(Rent.saveRent(null));
    dispatch(Reservation.saveReserve(null));
    checkFavicon(stockList);
  }, [dispatch, stockList, isFirstRoute]);

  useEffect(() => {
    timerRef.current = setInterval(() => {
      dispatch(Stock.pingStockList());
      checkFavicon(stockList);
    }, 5000);
    return () => {
      clearInterval(timerRef.current);
    };
  });

  useEffect(() => {
    if (!userOption) {
      dispatch(Auth.getUserOption());
    }
  }, [userOption]);

  useEffect(() => {
    setStockQueryParam(stock ? stock.stockID1C : undefined);
  }, [stock]);


  const checkFavicon = (currentStockList) => {
    if (!currentStockList) {
      return;
    }
    let reserveClientFrontCount = currentStockList.reduce((acc, current) => {
      return (acc += current.reserve_client_front_count);
    }, 0);
    setCount(reserveClientFrontCount);
  };

  const handleStatus = (value) => {
    setStatus(value);
  };

  const handleSearch = (item, string) => {
    setColumnSearch({ item, string });
  };

  const handleNavbar = (item) => {
    dispatch(Stock.setStock(item));
  };

  return (
    <>
      <Helmet>
        <link rel="icon" type="image/png" sizes="128x128" href={favicon}></link>
      </Helmet>

      <div className="body-flex">
        <Navbar
          active={stock || {}}
          onClick={handleNavbar}
          list={stockList}
          setIsTable={setIsTable}
          item={item}
          itemQueryParam={itemQueryParam}
          setItem={setItem}
        />

        <div className="main-content">
          <MainHeader
            isTable={isTable}
            columnSearch={columnSearch}
            setIsTable={setIsTable}
            title={stock && stock.stockName}
            user={userData}
            status={status}
            item={item}
            setItem={setItem}
            setStatus={handleStatus}
            notifications={{
              count: 0,
              list: [],
            }}
            onSearch={(item, string) => handleSearch(item, string)}
          />

          <div className="main-columns scrollable-x">
            <MainPageContent
              stock={stock}
              search={columnSearch}
              isTable={isTable}
              status={status}
              item={item}
              itemQueryParam={itemQueryParam}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export { MainPage };
